import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BookWithChapters } from 'src/modules/shared/types';

type ModalProps = { opened: boolean; title: string };
const DEFAULT_PAGE_WIDTH = 85;

export interface IPrivatePageSettingsState {
  book: BookWithChapters | undefined;
  pageWidth: number;
  knowledgeBase: string;
  modalProps: ModalProps;
  currentRouteName?: string | undefined;
}

const initialState: IPrivatePageSettingsState = {
  book: undefined,
  pageWidth: DEFAULT_PAGE_WIDTH,
  knowledgeBase: '',
  modalProps: { opened: false, title: 'Test Modal' },
};

const privatePageSettingsSlice = createSlice({
  name: 'privatePageSettings',
  initialState,
  reducers: {
    setBook: (state, action: PayloadAction<BookWithChapters | undefined>) => {
      state.book = action.payload;
    },
    setPageWidth: (state, action: PayloadAction<number | undefined>) => {
      state.pageWidth = action.payload || DEFAULT_PAGE_WIDTH;
    },
    setKnowledgeBase: (state, action: PayloadAction<string>) => {
      state.knowledgeBase = action.payload;
    },
    setModalProps: (state, action: PayloadAction<ModalProps>) => {
      state.modalProps = action.payload;
    },
    setCurrentRouteName: (state, action: PayloadAction<string | undefined>) => {
      state.currentRouteName = action.payload;
    }
  },
});

export const { setBook, setPageWidth, setKnowledgeBase, setModalProps, setCurrentRouteName } =
  privatePageSettingsSlice.actions;

export const { reducer: privatePageSettingsReducer } = privatePageSettingsSlice;
